import { Component, OnInit } from '@angular/core';
import { akrtiLastestServices } from "./services.data";
export interface AkrtiServices{
  category: string,
  services: string[],
}

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.less']
})
export class ServiceComponent implements OnInit {


  ourServices:AkrtiServices[] = akrtiLastestServices;

  constructor() { }

  ngOnInit() {
  }

}
